// Returns 'AEST' or 'AEDT' for the given instant, derived from the real
// Australia/Melbourne offset rather than a hardcoded string, so it flips
// automatically at each DST transition. Locale is pinned to 'en-AU' —
// other locales (e.g. en-US, en-GB) return 'GMT+10'/'GMT+11' instead of
// the AEST/AEDT abbreviation, regardless of the visitor's own locale.
export function getMelbourneTimezoneAbbr(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-AU', {
    timeZone: 'Australia/Melbourne',
    timeZoneName: 'short',
  }).formatToParts(date)

  return parts.find(part => part.type === 'timeZoneName').value
}
